module.exports = __webpack_public_path__ + "img/version.c8ac14c0.svg";